import React, {useEffect, useState} from 'react';
import {Col, Container, Form, Row} from 'react-bootstrap';
import moment from "moment";
import {companyRegex, nameRegex} from './Regex.jsx';

import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import PostalAddressTFAF from "./PostalAddressTFAF";
import autosureLogo from '../images/Autosure/autosure-footer.png';
import rebrandedAutosureLogo from '../images/Autosure/autosure-logo-rebranded.svg';
import {useLocation} from "react-use";
import SaveEmailQuote from "./SaveEmailQuote";
import {useCookies} from "react-cookie";
import NavigateMBI from "./NavigateMBI";
import NavigateAAMBI from "./NavigateAAMBI";
import {useFeature} from "../hooks/useFeature";
import TooltipTFAF from "./common/TooltipTFAF";

const UserDetailsTFAF = (props) => {
    const [errors, setErrors] = useState({});
    const location = useLocation();
    const [showEmailPopup, setShowEmailPopup] = useState(false);
    const [cookie, setCookie] = useCookies(['jwt-token']);
    const useRebrandedAutosureLogo = useFeature('newAutosureLogo');
    let url = process.env.REACT_APP_MODE !== null && process.env.REACT_APP_MODE !== undefined && process.env.REACT_APP_MODE.includes('dev') ? 'http://localhost:8080/edge' : '/edge';
  const isAAPath = props.inputValues.source === 'AA' || props.inputValues.source === 'AA_MEMBER';
  const isVTNZPath = props.inputValues.source === 'VTNZ';
  const baseUrl = window.location.origin;

  useEffect(() => {
        window.scrollTo(0, 0)
        // Track the 'page loaded' event
    if (isAAPath) {
            // Push virtual pageview event to dataLayer for GTM
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'virtualPageview',
                'virtualUrl': '/personal_details',
                'pageTitle': 'Personal Details'
            });
    }
    if (!window.location.hostname.includes('aa')) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'mbiAutosureEvent',
        category: 'Page View',
        virtualUrl: `${baseUrl}/mbi/step3`,
        pageTitle: 'Policyholder',
      });
    }
    if (window.gtag && isAAPath) {
      window.gtag('event', 'Page visited', {
        event_category: 'Page', event_label: 'User detail page',
      });
    }
    }, [])
  const handleDateChange = (e) => {
    let inputVal = e.target.value;
    const prevValue = e.target.getAttribute('data-prev') || "";

    // Remove all non-digit characters to count digits
    let digits = inputVal.replace(/\D/g, '');

    // Limit to 8 digits (DDMMYYYY)
    if (digits.length > 8) {
      digits = digits.slice(0, 8);
    }

    // Rebuild the input with slashes
    let formatted = '';
    if (digits.length > 0) formatted += digits.slice(0, 2);
    if (digits.length >= 3) formatted += '/' + digits.slice(2, 4);
    if (digits.length >= 5) formatted += '/' + digits.slice(4, 8);

    // Determine if user is deleting
    const isDeleting = prevValue.length > inputVal.length;

    // If deleting, allow raw value temporarily (no force-reformat)
    if (isDeleting) {
      formatted = inputVal;
    }

    // Store current value to detect typing direction next time
    e.target.setAttribute('data-prev', formatted);

    // Set formatted value and propagate change
    e.target.value = formatted;
    props.handleChange(e);
  };
  const saveAndEmailQuote = async (e) => {
      setErrors({});
    e.preventDefault();
      const newErrors = await findFormErrors();
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors)

      } else {

        let renewalId;
        let search = window.location.search;
        let params = new URLSearchParams(search);
        if (params.get('id') != null) {
          renewalId = encodeURIComponent(params.get('id'))
        } else {
          renewalId = props.inputValues.id;

        }
        let jwt = Cookies.get('jwt-token');
        fetch(url + "/prospect/applicant/renewal/" + renewalId, {
          method: "POST",
          mode: "cors",
          headers: new Headers({
            "Content-Type": "application/json",
            "Authorization": `Bearer ${jwt}`
          }),
          body: JSON.stringify(
            {
              firstName: props.inputValues.firstName,
              surname: props.inputValues.lastName,
              dateOfBirth: props.inputValues.dateOfBirth,
              jointFirstName: props.inputValues.jointFirstName,
              jointSurname: props.inputValues.jointLastName,
              jointDateOfBirth: props.inputValues.jointDateOfBirth,
              addressLine1: props.inputValues.addressLine1,
              addressLine2: props.inputValues.addressLine2,
              suburb: props.inputValues.suburb,
              city: props.inputValues.city,
              postcode: props.inputValues.postcode,
              mobile: props.inputValues.mobile,
              phone: props.inputValues.phone,
              email: props.inputValues.email,
              applicantType: props.inputValues.applicantType,
              businessName: props.inputValues.applicantType === "Business" ? props.inputValues.businessName : null
            }),
        })
          .then((response) => {
            if (response.ok) {
              response.json().then((json) => {
                json.errors.map((err) => {
                  if (err.field === 'lastName')
                    newErrors.lastName = err.message;
                  if (err.field === 'firstName')
                    newErrors.firstName = err.message;
                  if (err.field.includes('dateOfBirth') && props.inputValues.applicantType !== "Business")
                    newErrors.dateOfBirth = err.message;
                  if (err.field.includes('jointFirstName') && props.inputValues.applicantType !== "Business")
                    newErrors.jointFirstName = err.message;
                  if (err.field.includes('jointLastName') && props.inputValues.applicantType !== "Business")
                    newErrors.jointLastName = err.message;
                  if (err.field.includes('jointDob') && props.inputValues.applicantType !== "Business")
                    newErrors.jointDateOfBirth = err.message;
                  if (err.field.includes('houseNo'))
                    newErrors.addressLine1 = err.message;
                  if (err.field.includes('suburb'))
                    newErrors.suburb = err.message;
                  if (err.field.includes('city'))
                    newErrors.suburb = err.message;
                  if (err.field.includes('postcode'))
                    newErrors.suburb = err.message;
                  if (err.field.includes('phone'))
                    newErrors.phone = err.message;
                  if (err.field.includes('email'))
                    newErrors.email = err.message;
                })
                if (Object.keys(newErrors).length > 0) {
                  // We got errors!
                  setErrors(newErrors)

                } else {
                  setShowEmailPopup(true);
                  if (!window.location.hostname.includes('aa')) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                      event: 'mbiAutosureEvent',
                      category: 'Email My Quote Start',
                      virtualUrl: `${baseUrl}/mbi/step3`,
                      pageTitle: 'Policyholder',
                    });
                  }
                  }

              });

            }
          })
          .catch((err) => console.error("Caught error: ", err));
      }
    }

    const proceedWithPayment = () => {

        let renewalId;
        let search = window.location.search;
        let params = new URLSearchParams(search);
        if (params.get('id') != null) {
            renewalId = encodeURIComponent(params.get('id'))
        } else {
            renewalId = props.inputValues.id;
        }


        let jwt = Cookies.get('jwt-token');
        let fullName = props.inputValues.firstName + " " + props.inputValues.lastName
      let source = props.inputValues.source;
        // Override source for AA members
        if (isAAPath && props.inputValues.validAaMember === 'YES' && props.inputValues.aaMember === 'YES') {
          source = 'AA_MEMBER';
        }

        fetch(url + "/prospect/payment?renewalId=" + renewalId + "&applicantName=" + fullName + "&source="+source, {
            method: "GET",
            mode: "cors",
            headers: new Headers({
                "Content-Type": "application/json",
                "Authorization": `Bearer ${jwt}`
            }),

        })
            .then((response) => {
                response.text().then(function (text) {
                    props.handleChangeValue('sessionTimeout', props.inputValues.sessionTimeout + 1);
                    console.log('extending time');
                    let jwt = Cookies.get('jwt-token');
                    setCookie('jwt-token', jwt, {
                        path: '/',
                        maxAge: props.inputValues.sessionTimeout
                    });
                    props.handleChangeValue('showCookieExpiryPopup', false);
                    props.handleChangeValue('expireSession', false);
                    window.location.href = text;
                });


            })
            .catch((err) => console.error("Caught error: ", err));

    }

    const saveAndContinue = async (e) => {
        e.preventDefault();
        setErrors({});

        const newErrors = await findFormErrors();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors)
            if (!window.location.hostname.includes('aa')) {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: 'mbiAutosureEvent',
                category: 'Submit',
                categoryDetails: 'Card',
                customerType: props.inputValues.applicantType === 'Private' ? 'Personal' : props.inputValues.applicantType,
                status: 'Fail',
                virtualUrl: `${baseUrl}/mbi/step3`,
                pageTitle: 'Policyholder',
              });
            }
        } else {
            let renewalId;
            let search = window.location.search;
            let params = new URLSearchParams(search);
            if (params.get('id') != null) {
                renewalId = encodeURIComponent(params.get('id'))
            } else {
                renewalId = props.inputValues.id;

            }
            let jwt = Cookies.get('jwt-token');
            fetch(url + "/prospect/applicant/renewal/" + renewalId, {
                method: "POST",
                mode: "cors",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${jwt}`
                }),
                body: JSON.stringify(
                    {
                        firstName: props.inputValues.firstName,
                        surname: props.inputValues.lastName,
                        dateOfBirth: props.inputValues.dateOfBirth,
                        jointFirstName: props.inputValues.jointFirstName,
                        jointSurname: props.inputValues.jointLastName,
                        jointDateOfBirth: props.inputValues.jointDateOfBirth,
                        addressLine1: props.inputValues.addressLine1,
                        addressLine2: props.inputValues.addressLine2,
                        suburb: props.inputValues.suburb,
                        city: props.inputValues.city,
                        postcode: props.inputValues.postcode,
                        mobile: props.inputValues.mobile,
                        phone: props.inputValues.phone,
                        email: props.inputValues.email,
                        applicantType: props.inputValues.applicantType,
                        businessName: props.inputValues.applicantType === "Business" ? props.inputValues.businessName : null
                    }),
            })
                .then((response) => {
                    if (response.ok) {
                        response.json().then((json) => {
                            json.errors.map((err) => {
                                if (err.field === 'lastName')
                                    newErrors.lastName = err.message;
                                if (err.field === 'firstName')
                                    newErrors.firstName = err.message;
                                if (err.field.includes('dateOfBirth'))
                                    newErrors.dateOfBirth = err.message;
                                if (err.field.includes('jointFirstName'))
                                    newErrors.jointFirstName = err.message;
                                if (err.field.includes('jointLastName'))
                                    newErrors.jointLastName = err.message;
                                if (err.field.includes('jointDob'))
                                    newErrors.jointDateOfBirth = err.message;
                                if (err.field.includes('houseNo'))
                                    newErrors.addressLine1 = err.message;
                                if (err.field.includes('suburb'))
                                    newErrors.suburb = err.message;
                                if (err.field.includes('city'))
                                    newErrors.suburb = err.message;
                                if (err.field.includes('postcode'))
                                    newErrors.suburb = err.message;
                                if (err.field.includes('phone'))
                                    newErrors.phone = err.message;
                                if (err.field.includes('email'))
                                    newErrors.email = err.message;
                            })
                            if (Object.keys(newErrors).length > 0) {
                                // We got errors!
                                setErrors(newErrors)
                                if (!window.location.hostname.includes('aa')) {
                                  window.dataLayer = window.dataLayer || [];
                                  window.dataLayer.push({
                                    event: 'mbiAutosureEvent',
                                    category: 'Submit',
                                    categoryDetails: 'Card',
                                    customerType: props.inputValues.applicantType === 'Private' ? 'Personal' : props.inputValues.applicantType,
                                    status: 'Fail',
                                    virtualUrl: `${baseUrl}/mbi/step3`,
                                    pageTitle: 'Policyholder',
                                  });
                                }

                            } else {

                                if (!window.location.hostname.includes('aa')) {
                                  window.dataLayer = window.dataLayer || [];
                                  window.dataLayer.push({
                                    event: 'mbiAutosureEvent',
                                    category: 'Submit',
                                    categoryDetails: 'Card',
                                    customerType: props.inputValues.applicantType === 'Private' ? 'Personal' : props.inputValues.applicantType,
                                    status: 'Success',
                                    virtualUrl: `${baseUrl}/mbi/step3`,
                                    pageTitle: 'Policyholder',
                                  });
                                }

                              proceedWithPayment();
                            }

                        });

                    }
                })
                .catch((err) => {
                    console.error("Caught error: ", err);
                    if (!window.location.hostname.includes('aa')) {
                      window.dataLayer = window.dataLayer || [];
                      window.dataLayer.push({
                        event: 'mbiAutosureEvent',
                        category: 'Submit',
                        categoryDetails: 'Card',
                        customerType: props.inputValues.applicantType === 'Private' ? 'Personal' : props.inputValues.applicantType,
                        status: 'Fail',
                        virtualUrl: `${baseUrl}/mbi/step3`,
                        pageTitle: 'Policyholder',
                      });
                    }
                });
        }
    };


    const findFormErrors = async () => {
      const newErrors = {}
      const dateFormat = 'DD/MM/YYYY';
      // name errors
      // name errors
      if (!props.inputValues.firstName || props.inputValues.firstName === '') {
            newErrors.firstName = 'Please enter your first name'
        } else if (props.inputValues.firstName.length > 50) {
            newErrors.firstName = 'First name too long.'
      } else if (!nameRegex.test(props.inputValues.firstName)) {
        newErrors.firstName = 'Only letters, -, \' and space are allowed.'
        }
        if (!props.inputValues.applicantType || props.inputValues.applicantType === '') {
            newErrors.applicantType = 'Please select applicant type'
        }
        if (!props.inputValues.lastName || props.inputValues.lastName === '') {
            newErrors.lastName = 'Please enter your last name'
        } else if (props.inputValues.lastName.length > 50) {
            newErrors.lastName = 'Last name too long.'
        } else if (!nameRegex.test(props.inputValues.lastName)) {
          newErrors.lastName = 'Only letters, -, \' and space are allowed.'
        }
        if ((props.inputValues.applicantType === "Business") && (!props.inputValues.businessName || props.inputValues.businessName === '')) {
            newErrors.businessName = 'Please enter business name'
        } else if (props.inputValues.businessName != null && props.inputValues.businessName.length > 50) {
            newErrors.businessName = 'Business name too long.'
        } else if ((props.inputValues.applicantType === "Business") && props.inputValues.businessName != null && !companyRegex.test(props.inputValues.businessName)) {
            newErrors.businessName = "Only letters, -, ' and space are allowed."
        }
      if (props.inputValues.applicantType !== "Business") {
        if ((!props.inputValues.dateOfBirth || props.inputValues.dateOfBirth === ''))
            newErrors.dateOfBirth = 'Please enter date of birth'
        else {
            let dob = props.inputValues.dateOfBirth;
            const array = dob.split("/");
            if (array.length == 3) {
                let day = ('0' + array[0]).slice(-2);
                let month = ('0' + array[1]).slice(-2);
                dob = day + '/' + month + '/' + array[2];
                props.handleChangeValue('dateOfBirth', dob);
            }
            let isValid = moment(dob, 'DD/MM/YYYY', true);
            if (!isValid.isValid()) {
                newErrors.dateOfBirth = 'Invalid date. Please enter date in format dd/mm/yyyy.'
            } else {
                let dobDate = moment(dob, 'DD/MM/YYYY', true);
                let year = new Date().getFullYear();
                if (dobDate.year() < 1900 || dobDate.year() > year) {
                    newErrors.dateOfBirth = 'Date of birth is invalid.'
                } else {
                    let age = calculateAge(props.inputValues.dateOfBirth);

                    if (age < 16) {
                      newErrors.dateOfBirth = 'Age should be more than 16 years old'
                    } else if (age > 115) {
                        newErrors.dateOfBirth = 'Age should be less than 115 years.'
                    }
                }
            }

        }
      }
      if (props.inputValues.joint && props.inputValues.applicantType !== "Business") {
            if (!props.inputValues.jointFirstName || props.inputValues.jointFirstName === '') {
                newErrors.jointFirstName = 'Please enter first name'
            } else if (props.inputValues.jointFirstName.length > 50) {
                newErrors.jointFirstName = 'First name too long.'
            } else if (!nameRegex.test(props.inputValues.jointFirstName)) {
                newErrors.jointFirstName = 'Only letters, -, \' and space are allowed.'
            }

            if (!props.inputValues.jointLastName || props.inputValues.jointLastName === '') {
                newErrors.jointLastName = 'Please enter last name'
            } else if (props.inputValues.jointLastName.length > 50) {
                newErrors.jointLastName = 'Last name too long.'
            } else if (!nameRegex.test(props.inputValues.jointLastName)) {
                newErrors.jointLastName = 'Only letters, -, \' and space are allowed.'
            }
          if (props.inputValues.applicantType !== "Business") {
            if (!props.inputValues.jointDateOfBirth || props.inputValues.jointDateOfBirth === '')
                newErrors.jointDateOfBirth = 'Please enter date of birth'
            else {
                let dob = props.inputValues.jointDateOfBirth;
                const array = dob.split("/");
                if (array.length == 3) {
                    let day = ('0' + array[0]).slice(-2);
                    let month = ('0' + array[1]).slice(-2);
                    dob = day + '/' + month + '/' + array[2];
                    props.handleChangeValue('jointDateOfBirth', dob);
                }
                let isValid = moment(dob, 'DD/MM/YYYY', true);
                if (!isValid.isValid()) {
                    newErrors.jointDateOfBirth = 'Invalid date. Please enter date in format dd/mm/yyyy.'
                } else {
                    let dobDate = moment(dob, 'DD/MM/YYYY', true);
                    let year = new Date().getFullYear();
                    if (dobDate.year() < 1900 || dobDate.year() > year) {
                        newErrors.jointDateOfBirth = 'Date of birth is invalid.'
                    } else {
                        let age = calculateAge(props.inputValues.jointDateOfBirth);

                        if (age < 16) {
                          newErrors.jointDateOfBirth = 'Age should be more than 16 years old'
                        } else if (age > 115) {
                            newErrors.jointDateOfBirth = 'Age should be less than 115 years.'
                        }
                    }
                }
            }
          }
        }
        if (!props.inputValues.full_address || props.inputValues.full_address === '') {
            newErrors.full_address = 'Please enter the address'
        }

        let isAddressError = false;
        if (!props.inputValues.addressLine1 || props.inputValues.addressLine1 === '') {
            newErrors.addressLine1 = 'Please enter details.'
            isAddressError = true;
        } else if (props.inputValues.addressLine1.length > 100) {
            newErrors.addressLine1 = 'Address line 1 too long.'
            isAddressError = true;
        }

        if (props.inputValues.addressLine2.length > 100) {
            newErrors.addressLine2 = 'Address line 2 too long.'
            isAddressError = true;
        }

        if (!props.inputValues.suburb || props.inputValues.suburb === '') {
            newErrors.suburb = 'Please enter details.'
            isAddressError = true;
        } else if (props.inputValues.suburb.length > 100) {
            newErrors.suburb = 'Suburb too long.'
            isAddressError = true;
        }

        if (!props.inputValues.city || props.inputValues.city === '') {
            newErrors.city = 'Please enter details.'
            isAddressError = true;
        } else if (props.inputValues.city.length > 100) {
            newErrors.city = 'City too long.'
            isAddressError = true;
        }

        if (!props.inputValues.postcode || props.inputValues.postcode === '') {
            newErrors.postcode = 'Please enter details.'
            isAddressError = true;
        } else if (props.inputValues.postcode.length > 4) {
            newErrors.postcode = 'Invalid postcode.'
            isAddressError = true;
        }
        if (!newErrors.full_address && isAddressError) {
            newErrors.full_address = 'Please check manual address for errors.'
        }
      if (props.inputValues.phone.length === 0) {
            newErrors.phone = 'Please enter your phone number'

        } else if (props.inputValues.phone.length > 15) {
            newErrors.phone = 'Phone number too long.'
        }

        if (!props.inputValues.email || props.inputValues.email === '') {
            newErrors.email = 'Please enter a valid email address'
        } else if (props.inputValues.email.length > 100) {
            newErrors.email = 'Email address too long.'
        } else {
            let jwt = Cookies.get('jwt-token');
            if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(props.inputValues.email)) {
              try {
                const response = await fetch(url + "/policy/email/validate?address=" + props.inputValues.email, {
                  method: "GET",
                  mode: "cors",
                  headers: new Headers({
                    "Content-Type": "application/json",
                    "Authorization": "By-Pass-Auth-Create-Prospect"
                  }),
                });

                if (response.ok) {
                  const json = await response.json();
                  if (json.result === 'false') {
                    newErrors.email = 'Email address is invalid';
                  }
                }
              } catch (err) {
                console.error("Caught error: ", err);
              }
            } else {
                newErrors.email = 'Email address format is invalid';
            }
        }
      if (Object.keys(newErrors).length > 0) {
        newErrors.titleError = "Please update the highlighted fields below and click 'Next'.";
      }
      return newErrors
    }

    const calculateAge = (dateEntered) => {
        var from = dateEntered.split("/");
        var birthdateTimeStamp = new Date(from[2], from[1] - 1, from[0]);
        var cur = new Date();
        var diff = cur - birthdateTimeStamp;
// This is the difference in milliseconds
        var currentAge = Math.floor(diff/31557600000);
// Divide by 1000*60*60*24*365.25

        return currentAge;
    }
    const steps = [// {name: 'Step 1', status: 'complete'},
      {name: 'Step 1', status: 'complete', desc: 'Car details'}, {
            name: 'Step 2', status: 'complete', desc: 'Choose your cover'
      }, {name: 'Step 3', status: 'current', desc: 'About you'}, {
            name: 'Step 4', status: 'upcoming', desc: 'Pay now'
        },];

    return (
        <Container className='container-padding'>
            <>
              <br/>
                <Row className="justify-content-center">
                  {isAAPath ? (
                    <> <br/>
                      <NavigateAAMBI steps={steps}/> </>
                  ) : (
                    <NavigateMBI steps={steps}/>
                  )}
                </Row>
                <br/>
                <br/>
                <div style={{display: 'flex', justifyContent: "center"}}>
                    <Form>
                        <Form.Group>
                            <div className="subHeadingStyles">Policyholder</div>
                        </Form.Group><Col md="1"/>
                      {errors.titleError && (
                        <>
                          <div className="regularErrorStyle">{errors.titleError}</div>
                        </>
                      )}
                        <div style={{paddingTop:"20px",paddingBottom:"10px"}}><span className="boldTextStyles">Would you like your policy under a private or business name?</span> </div>
                        <Form.Group md="5" as={Col} controlId="formApplicantType" className="form-group">
                            <div className="d-flex">
                                <Form.Check
                                    type="radio"
                                    id="applicantTypePrivate"
                                    label="Private"
                                    name="applicantType"
                                    value="Private"
                                    checked={props.inputValues.applicantType === "Private"}
                                    onChange={props.handleChange}
                                    required
                                    isInvalid={!!errors.applicantType}
                                    className="me-3"
                                />
                                <Form.Check
                                    type="radio"
                                    id="applicantTypeBusiness"
                                    label="Business"
                                    name="applicantType"
                                    value="Business"
                                    checked={props.inputValues.applicantType === "Business"}
                                    onChange={props.handleChange}
                                    required
                                    isInvalid={!!errors.applicantType}
                                />
                            </div>
                            <Form.Control.Feedback type="invalid">
                                {errors.applicantType}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <br/>
                        {props.inputValues.source === 'TFAF' &&
                            <div className="boldTextStyles">Update the details below if the policyholder will be a
                                different person from you. If not, just enter your address and date of birth.
                            </div>}
                        <div style={{display: "flex", justifyContent: "space-between"}} className="column-on-mobile">
                            <Form.Group md="5" as={Col} controlId="formFirstName" className="form-group">
                                <Form.Label className="regularTextStyles">First Name </Form.Label>
                                <Form.Control
                                    type="text"
                                    className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                    style={{
                                        background: 'white',
                                        boxShadow: '4px 5px 13px -3px rgba(0,0,0,1)',
                                        borderRadius: 6,
                                        overflow: 'hidden',
                                        border: '1px #E5E7EB solid',
                                    }}
                                    defaultValue={(props.inputValues.firstName)}
                                    name="firstName"
                                    required
                                    onChange={props.handleChange}
                                    isInvalid={!!errors.firstName}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.firstName}
                                </Form.Control.Feedback>
                            </Form.Group><Col md="1"/>
                            <Form.Group as={Col} md="5" controlId="formLastName" className="form-group">
                                <Form.Label className="label regularTextStyles">Last
                                    Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                    style={{
                                        background: 'white',
                                        boxShadow: '4px 5px 13px -3px rgba(0,0,0,1)',
                                        borderRadius: 6,
                                        overflow: 'hidden',
                                        border: '1px #E5E7EB solid',
                                    }}
                                    defaultValue={props.inputValues.lastName}
                                    name="lastName"
                                    required
                                    isInvalid={!!errors.lastName}
                                    onChange={props.handleChange}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.lastName}
                                </Form.Control.Feedback>
                            </Form.Group><Col md="1"/>
                        </div>
                        <br/>
                        <div style={{display: "flex", justifyContent: "space-between"}} className="column-on-mobile">
                            <Form.Group as={Col} md="5" controlId="validationCustom02" className="form-group">
                                <Form.Label className="regularTextStyles">Phone</Form.Label>
                                <Form.Control
                                    className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                    style={{
                                        background: 'white',
                                        boxShadow: '4px 5px 13px -3px rgba(0,0,0,1)',
                                        borderRadius: 6,
                                        overflow: 'hidden',
                                        border: '1px #E5E7EB solid',
                                    }}
                                    required
                                    type="number"
                                    name="phone"
                                    defaultValue={props.inputValues.phone}
                                    value={props.phone}
                                    onChange={props.handleChange}
                                    isInvalid={!!errors.phone}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.phone}
                                </Form.Control.Feedback>
                            </Form.Group><Col md="1"/>

                            <Form.Group as={Col} md="5" controlId="validationCustom02" className="form-group">
                                <Form.Label className="regularTextStyles">Email</Form.Label>
                                <Form.Control
                                    className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                    style={{
                                        background: 'white',
                                        boxShadow: '4px 5px 13px -3px rgba(0,0,0,1)',
                                        borderRadius: 6,
                                        overflow: 'hidden',
                                        border: '1px #E5E7EB solid',
                                    }}
                                    required
                                    type="text"
                                    name="email"
                                    defaultValue={props.inputValues.email}
                                    value={props.email}
                                    onChange={props.handleChange}
                                    isInvalid={!!errors.email}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.email}
                                </Form.Control.Feedback>
                            </Form.Group><Col md="1"/>
                        </div>
                        <br/>
                        {props.inputValues.applicantType === "Business" && (
                            <div style={{display: "flex", justifyContent: "space-between"}}
                                 className="column-on-mobile">
                                <Form.Group as={Col} md="11">
                                    <Form.Label className='formHeader regularTextStyles'>Business
                                        Name</Form.Label>
                                    <Form.Control
                                        className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                        defaultValue={(props.inputValues.businessName)}
                                        name="businessName"
                                        required
                                        onChange={props.handleChange}
                                        isInvalid={!!errors.businessName}
                                        style={{
                                            background: 'white',
                                            boxShadow: '4px 5px 13px -3px rgba(0,0,0,1)',
                                            borderRadius: 6,
                                            overflow: 'hidden',
                                            border: '1px #E5E7EB solid',
                                        }}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.businessName}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        )}
                        <div style={{display: "flex", justifyContent: "space-between"}} className="column-on-mobile">
                            <PostalAddressTFAF
                                inputValues={props.inputValues}
                                errors={errors}
                                handleChange={props.handleChange}
                                handleChangeValue={props.handleChangeValue}
                                setErrors={setErrors}/>
                          <Col md="1"/>
                          {props.inputValues.applicantType !== "Business" && (<>
                            <Form.Group as={Col} md="5" controlId="formDateOfBirth" className="form-group">
                                <Form.Label className="regularTextStyles">Date of Birth</Form.Label>
                                <Form.Control
                                    type="text"
                                    className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                    style={{
                                        background: 'white',
                                        boxShadow: '4px 5px 13px -3px rgba(0,0,0,1)',
                                        borderRadius: 6,
                                        overflow: 'hidden',
                                        border: '1px #E5E7EB solid',
                                    }}
                                    required
                                    placeholder='dd/mm/yyyy'
                                    name="dateOfBirth"
                                    value={props.inputValues.dateOfBirth}
                                    isInvalid={!!errors.dateOfBirth}
                                    onChange={handleDateChange}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.dateOfBirth}
                                </Form.Control.Feedback>
                            </Form.Group>
                          </>)}
                          <Col md="1"/>

                        </div>
                      {!props.inputValues.joint && props.inputValues.applicantType !== "Business" && <>
                            <br/>
                            <div style={{display: "flex", justifyContent: "space-between"}}
                                 className="column-on-mobile">
                                <div style={{display: 'flex'}}>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <g id="Add user">
                                            <g id="Icon">
                                                <path
                                                    d="M8 9C9.65685 9 11 7.65685 11 6C11 4.34315 9.65685 3 8 3C6.34315 3 5 4.34315 5 6C5 7.65685 6.34315 9 8 9Z"
                                                    fill={isVTNZPath ? "#E87722" : "#0073CF"}/>
                                                <path d="M8 11C11.3137 11 14 13.6863 14 17H2C2 13.6863 4.68629 11 8 11Z"
                                                      fill={isVTNZPath ? "#E87722" : "#0073CF"}/>
                                                <path
                                                    d="M16 7C16 6.44772 15.5523 6 15 6C14.4477 6 14 6.44772 14 7V8H13C12.4477 8 12 8.44771 12 9C12 9.55228 12.4477 10 13 10H14V11C14 11.5523 14.4477 12 15 12C15.5523 12 16 11.5523 16 11V10H17C17.5523 10 18 9.55228 18 9C18 8.44772 17.5523 8 17 8H16V7Z"
                                                    fill={isVTNZPath ? "#E87722" : "#0073CF"}/>
                                            </g>
                                        </g>
                                    </svg>
                                    &nbsp;&nbsp;
                                    <a
                                        onClick={() => props.handleChangeValue("joint", true)}
                                        style={{
                                          textDecoration: 'underline',
                                          cursor: 'pointer',
                                          color: isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#0073CF'
                                        }}>
                                        Add another policyholder
                                    </a>
                                  <TooltipTFAF
                                    placement="top"
                                    title="Adding a policyholder means both people will have the same rights with regard to the policy. For example, they can request policy detail updates e.g. address, and make claims."
                                  >
                                    <i className="fa fa-info-circle"/>
                                  </TooltipTFAF>
                                </div>
                                <br/>
                            </div>
                        </>}

                      {props.inputValues.joint && props.inputValues.applicantType !== "Business" ? <>
                            <br/>
                            <div className="boldTextStyles">Joint Policyholder</div>

                            <Col md="1"/>
                            <div>
                                <div style={{display: "flex", justifyContent: "space-between"}}>
                                    <Form.Group md="5" as={Col} controlId="formJointFirstName" className="form-group">
                                        <Form.Label className="regularTextStyles">First Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                            style={{
                                                background: 'white',
                                                boxShadow: '4px 5px 13px -3px rgba(0,0,0,1)',
                                                borderRadius: 6,
                                                overflow: 'hidden',
                                                border: '1px #E5E7EB solid',
                                            }}
                                            defaultValue={props.inputValues.jointFirstName}
                                            name="jointFirstName"
                                            required
                                            onChange={props.handleChange}
                                            isInvalid={!!errors.jointFirstName}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.jointFirstName}
                                        </Form.Control.Feedback>
                                    </Form.Group><Col md="1"/>
                                    <Form.Group as={Col} md="5" controlId="formJointLastName" className="form-group">
                                        <Form.Label className="label regularTextStyles">Last Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                            style={{
                                                background: 'white',
                                                boxShadow: '4px 5px 13px -3px rgba(0,0,0,1)',
                                                borderRadius: 6,
                                                overflow: 'hidden',
                                                border: '1px #E5E7EB solid',
                                            }}
                                            defaultValue={props.inputValues.jointLastName}
                                            name="jointLastName"
                                            required
                                            isInvalid={!!errors.jointLastName}
                                            onChange={props.handleChange}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.jointLastName}
                                        </Form.Control.Feedback>
                                    </Form.Group><Col md="1"/>
                                </div>
                              {props.inputValues.applicantType !== "Business" && (<>
                                <Form.Group as={Col} md="5" controlId="formJointDateOfBirth" className="form-group">
                                    <Form.Label className="regularTextStyles">Date of Birth</Form.Label>
                                    <Form.Control
                                        type="text"
                                        className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                        style={{
                                            background: 'white',
                                            boxShadow: '4px 5px 13px -3px rgba(0,0,0,1)',
                                            borderRadius: 6,
                                            overflow: 'hidden',
                                            border: '1px #E5E7EB solid',
                                        }}
                                        required
                                        name="jointDateOfBirth"
                                        placeholder='dd/mm/yyyy'
                                        value={props.inputValues.jointDateOfBirth}
                                        isInvalid={!!errors.jointDateOfBirth}
                                        onChange={handleDateChange}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.jointDateOfBirth}
                                    </Form.Control.Feedback>
                                </Form.Group>
                              </>)}
                              <Col md="1"/>
                            </div>
                            <br/>
                            <div style={{color: "red"}}>-&nbsp;&nbsp;
                                <a
                                    onClick={() => {
                                        // Reset joint applicant fields when removing joint applicant
                                        props.handleChangeValue("joint", false);
                                        props.handleChange({target: {name: 'jointFirstName', value: ''}});
                                        props.handleChange({target: {name: 'jointLastName', value: ''}});
                                        props.handleChange({target: {name: 'jointDateOfBirth', value: ''}});
                                    }}
                                    style={{textDecoration: 'underline', cursor: 'pointer', color: "red"}}>
                                    Remove joint policyholder
                                </a>
                            </div>
                        </> : ""}
                      <br/><br/>
                      <div style={{paddingBottom: "10px"}}><span className="subHeadingStyles subHeadingBlackVTNZ">What's next</span>
                      </div>

                      <div style={{display: "flex", alignItems: "center"}}>
                        <div><img src={useRebrandedAutosureLogo ? rebrandedAutosureLogo : autosureLogo} style={{height: "inherit"}} alt="Autosure Logo"/></div>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <div className="regularTextStyles">
                                The next step is to pay by credit or debit card.
                                <br/>
                              Your payment will be to Autosure Insurance Limited, the underwriter of this policy.
                            </div>
                        </div>
                        <p>&nbsp;</p>
                        { (props.inputValues.source === 'AA' || props.inputValues.source === 'AA_MEMBER' || props.inputValues.source === 'MYAUTOSHOP' || props.inputValues.source === 'MONEYHUB' ||props.inputValues.source === 'TFAF_AUTOSURE') &&
                          props.inputValues.saveQuoteButtonEnabled &&
                            <p
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: "center",
                                  paddingTop: '10px'
                                }}>
                              <div style={{
                                flex: 1, maxWidth: "200px",
                              }}></div>
                                <SaveEmailQuote showEmailPopup={showEmailPopup} setShowEmailPopup={setShowEmailPopup} inputValues={props.inputValues}/>
                                <button
                                    type="button"
                                    onClick={saveAndEmailQuote}
                                    style={{
                                        color: 'white',
                                        boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                                      flex: 1,
                                      borderRadius: isAAPath || isVTNZPath ? 30 : 6,
                                      paddingLeft: 1,
                                      paddingRight: 1,
                                        paddingTop: 13,
                                        paddingBottom: 13,
                                        overflow: 'hidden',
                                        border: '1px white solid',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        display: 'inline-flex',
                                        width:"100%",
                                        maxWidth:"200px",
                                        background: props.inputValues.selectedTermAndCover ? '#AFAFb0' : '#AFAFb0',
                                        cursor: props.inputValues.selectedTermAndCover ? 'pointer' : 'not-allowed',
                                    }}
                                >
                                    Save & email quote
                                </button>

                            </p>
                        }
                        <p
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: "center",
                                paddingTop: '20px'
                            }}>
                            <button
                                className="btn rounded-md px-4 py-2.5 text-sm font-weight-bold text-gray-900 shadow-sm"
                                onClick={() => props.prevStep()}
                                style={{
                                  color: isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#1851a3',
                                    paddingLeft: 25,
                                    paddingRight: 25,
                                    paddingTop: 13,
                                    paddingBottom: 13,
                                    background: 'white',
                                  border: isVTNZPath ? '1px #E87722 solid' : '1px #1851A3 solid',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    display: 'inline-flex',
                                    wordWrap: 'break-word',
                                    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                                  borderRadius: isAAPath || isVTNZPath ? 30 : 6,
                                    width:"100%",
                                    maxWidth:"200px"
                                }}>
                                Back
                            </button>
                            <button className="float-end"
                                    onClick={saveAndContinue}
                                    style={{
                                        color: 'white',
                                        paddingLeft: 25,
                                        paddingRight: 25,
                                        paddingTop: 13,
                                        paddingBottom: 13,
                                        width:"100%",
                                        maxWidth:"200px",
                                      background: isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#1851a3',
                                        boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                                      borderRadius: isAAPath || isVTNZPath ? 30 : 6,
                                        overflow: 'hidden',
                                      border: isVTNZPath ? '1px #E87722 solid' : isAAPath ? '1px #0d59bf solid' : '1px #1851a3 solid',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        display: 'inline-flex',
                                        cursor: 'pointer',
                                        opacity: 1
                                    }}
                            >
                                Next
                            </button>
                        </p>
                        <br/><br/><br/><br/><br/><br/>
                    </Form></div>
            </>
        </Container>
    );

}

export default UserDetailsTFAF;
